import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Modal, Checkbox, Icon } from '@safedns/skydns-ui-react-lib';

import CircularProgress from '../UI/circular-progress';

import sprite from '../../icons/sprite.svg';

import {
  useGetUserQuery,
  useDeleteAuthKeyMutation,
} from '../../services/ADapi';
import { notificationSuccess } from '../../store/notificationReducer';
import styles from './DeleteAuthKeyDialog.module.scss';

const DeleteAuthKeyDialog = ({ isDialogShow, onDialogAction }) => {
  const dispatch = useDispatch();

  const [isChecked, setCheckboxState] = useState(false);

  const {
    data: { user_id },
  } = useGetUserQuery();
  const [deleteAuthKey, { isLoading }] = useDeleteAuthKeyMutation();

  const notificationData = {
    isNotification: true,
    type: 'success',
    message: 'AuthKey был удален',
  };

  const deleteDomainHandler = async () => {
    try {
      await deleteAuthKey({ user_id }).unwrap();
      onDialogAction();
      dispatch(notificationSuccess(notificationData));
    } catch (error) {
      console.error(error);
      onDialogAction();
    }
  };

  const checkboxStateHandler = () => {
    setCheckboxState((prevState) => !prevState);
  };

  return (
    <Modal
      title="Удалить ключ?"
      isOpen={isDialogShow}
      onClose={onDialogAction}
      sx={{ maxWidth: 460 }}
    >
      <div className={styles['dialog-content']}>
        <div className={styles['icon-wrapper']}>
          <Icon
            id="remove"
            sprite={sprite}
            width={24}
            height={24}
            color="white"
          />
        </div>

        <Checkbox
          label="Я понимаю, что удаление ключа приведет к его полной недоступности и его нельзя будет восстановить"
          isChecked={isChecked}
          onChange={checkboxStateHandler}
          className={styles['checkbox-wrapper']}
        />
        <div className={styles['button-grid']}>
          <Button
            variant="secondary"
            size="small"
            onClick={deleteDomainHandler}
            isDisabled={!isChecked || isLoading}
            className={styles['button-delete']}
          >
            Удалить
            {isLoading ? (
              <CircularProgress size={15} className={styles['loader']} />
            ) : null}
          </Button>
          <Button
            variant="primary"
            size="small"
            onClick={onDialogAction}
            className={styles['button-cancel']}
          >
            Отменить
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteAuthKeyDialog;
